import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <div className="min-h-80vh px-4 lg-px-27px xxl-px-89px">
        <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block">
          <div className="breadcrumbs max-w-[1400px] mx-auto py-2 md-py-4">
            <Link to="/" onClick={toTop}>Home</Link>
            <span className="px-2">/</span>
            <span>Shop</span>
          </div>
        </div>

        <div className="cms-root_cmsFullWidth-5e3">
          <div className="cms-root-63a">
            <div className="richContent-root-63a">
              <div className="row-contained-645">
                <div className="row-root-63a">
                  <div className="row-contained-inner">
                    <div className="text-root-63a">
                      <h1>Shop failblossom</h1>
                    </div>
                  </div>
                </div>
              </div>

              <div className="products-section">
                <div className="products-header">
                  <h2 className="section-title">Our Finest Selections</h2>
                  <p className="section-subtitle">
                    Explore our curated collection of hampers, gift boxes, and delightful treats
                  </p>
                </div>
                <div className="products-grid">
                  {productData.map((product, index) => (
                    <Link
                      to={`/shopDetails/${product.id}`}
                      key={product.id}
                      className="product-card"
                      onClick={toTop}
                    >
                      <div className="product-image">
                        <img src={product.image} alt={product.name} />
                      </div>
                      <div className="product-info">
                        <p className="product-category">{product.category}</p>
                        <h3 className="product-name">{product.name}</h3>
                        <p className="product-price">£{product.price}</p>
                        <div className="product-rating">
                          <span className="rating-stars">★★★★★</span>
                          <span className="rating-reviews">({product.reviews})</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shop;
